module.exports = __webpack_public_path__ + "img/checkouts-shortcut.afb7815e.svg";